import {
  createSafeDate,
  dateToDashString,
  dateToSlashString,
} from './dateUtility'
import { toFormattedDateString } from './toFormattedDateString'

/**
 * @deprecated
 * We will no longer use the 'MM/DD/YYYY' date format directly.
 * Please use `displayFormattedDashDate` with format MM-DD-YYYY for consistency
 * across the application.
 *
 * We bring in toFormattedDateString which converts yyyy-mm-dd to
 * full date (without time) ie 2021-08-13 --> Fri Aug 13 2021 */
export const displayFormattedDate = (
  startDate: string,
  endDate: string
): string => {
  return startDate === endDate
    ? toFormattedDateString(startDate)
    : /** We do this when we have a date range so that the start date 
    displays without the year and comma. */
      `${toFormattedDateString(startDate).slice(
        0,
        -6
      )} - ${toFormattedDateString(endDate)}`
}

/**
 * @deprecated
 * We will no longer use the 'MM/DD/YYYY' date format directly.
 * All dates should now be formatted using `displayFormattedDashDate` for consistency
 * across the application.
 */
export const displayFormattedSlashDate = (
  startDate: string,
  endDate: string
): string => {
  return startDate === endDate
    ? dateToSlashString(createSafeDate(startDate), true)
    : /** We do this when we have a date range so that the start date 
    displays without the year and comma. */
      `${dateToSlashString(
        createSafeDate(startDate),
        true
      )} - ${dateToSlashString(createSafeDate(endDate), true)}`
}

export const displayFormattedDashDate = (
  startDate: string,
  endDate: string
): string => {
  return startDate === endDate
    ? dateToDashString(createSafeDate(startDate), true)
    : /** We do this when we have a date range so that the start date 
    displays without the year and comma. */
      `${dateToDashString(
        createSafeDate(startDate),
        true
      )} - ${dateToDashString(createSafeDate(endDate), true)}`
}
